import { getToken } from './storage';

async function postAuth(path, body) {
  const response = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const error = new Error((data && data.error) || 'Request failed');
    error.status = response.status;
    throw error;
  }

  return data;
}

export function login({ email, password }) {
  return postAuth('/api/v1/users/login', { email, password });
}

export function signup({ email, password, name }) {
  return postAuth('/api/v1/users/signup', { email, password, name });
}

export async function fetchMe() {
  const token = getToken();
  if (!token) {
    const error = new Error('missing token');
    error.status = 401;
    throw error;
  }

  const response = await fetch('/api/v1/users/me', {
    headers: { Authorization: `Bearer ${token}` },
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const error = new Error((data && data.error) || 'Request failed');
    error.status = response.status;
    throw error;
  }

  return data;
}
